import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=5bb8d456&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=ts"
export * from "./EventDetails.vue?vue&type=script&lang=ts"
import style0 from "./EventDetails.vue?vue&type=style&index=0&id=5bb8d456&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb8d456",
  null
  
)

export default component.exports